import type { TFunction } from 'i18next'
import type { HistoryRow } from './historyApi'

export function kindLabel(t: TFunction, row: HistoryRow): string {
  return t(`subscriber.history.kind.${row.kind}`)
}

export function performerLabel(t: TFunction, row: HistoryRow): string {
  const actor = row.actor
  if (actor === null) return '—'
  switch (actor.type) {
    case 'STAFF':
      return actor.name ?? t('subscriber.history.actor.STAFF')
    case 'AGENT':
      return actor.name ?? t('subscriber.history.actor.AGENT')
    case 'PSP':
      return actor.name
        ? `${t('subscriber.history.actor.PSP')} · ${actor.name}`
        : t('subscriber.history.actor.PSP')
    default:
      return t('subscriber.history.actor.SYSTEM')
  }
}
